import { Injectable } from "@angular/core";
import { AppService } from "../core/service/Base.Service";
@Injectable()
export class AdmissionFormService extends AppService<any>  {


    constructor(){
        super('admisform');
    }



}


// WEBPACK FOOTER //
// ./src/app/admisform/admisformservice.ts